export const VERSION = '11.0.0-rc.3.26522.148';
//# sourceMappingURL=pkg-version.js.map